import { render } from "./footer.vue?vue&type=template&id=1ff4caa7&scoped=true"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=1ff4caa7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff4caa7"]])

export default __exports__